import { useMuseumStore } from '@/roc/stores/MuseumStore';
export var Calc;
(function (Calc) {
    Calc["flat"] = "flat";
    Calc["perLevel"] = "perLevel";
    Calc["callbackWithLevel"] = "callbackWithLevel";
    Calc["hourMinutePerLevel"] = "hourMinutePerLevel";
    Calc["perEraAndLevel"] = "perEraAndLevel";
    Calc["callbackWithLevelAndEra"] = "callbackWithLevelAndEra";
    Calc["perEra"] = "perEra";
    Calc["rangePerLevel"] = "rangePerLevel";
    Calc["museum"] = "museum";
})(Calc || (Calc = {}));
const _Calculator = {
    callbackWithLevel() { },
    callbackWithLevelAndEra() { },
    museum() { },
    flat: (a) => a,
    perLevel: (a, level) => a[level - 1],
    hourMinutePerLevel: (a, level) => a[level - 1][0] + 'h ' + a[level - 1][1] + 'm',
    perEraAndLevel: (a, level, era) => a[era][level - 1],
    perEra: (a, _, era) => a[era],
    rangePerLevel: (a, level) => a[level - 1].min + ' - ' + a[level - 1].max
};
// -----------------------------------------------------------------------
class EffectAmount {
    __calc;
    __amount;
    constructor(calc, amount) {
        this.__calc = calc;
        this.__amount = amount;
    }
    clone() {
        return new EffectAmount(this.__calc, this.__amount);
    }
    static asFlat(amount) {
        return new this(Calc.flat, amount);
    }
    static asPerLevel(amount) {
        return new this(Calc.perLevel, amount);
    }
    static asCallbackWithLevel(amount) {
        return new this(Calc.callbackWithLevel, amount);
    }
    static asHourMinutePerLevel(amount) {
        return new this(Calc.hourMinutePerLevel, amount);
    }
    static asPerEraAndLevel(amount) {
        return new this(Calc.perEraAndLevel, amount);
    }
    static asCallbackWithLevelAndEra(amount) {
        return new this(Calc.callbackWithLevelAndEra, amount);
    }
    static asPerEra(amount) {
        return new this(Calc.perEra, amount);
    }
    static asDaily() {
        return new this(Calc.flat, 24 * 60 * 60);
    }
    static asRangePerLevel(amount) {
        return new this(Calc.rangePerLevel, amount);
    }
    static asMuseum() {
        return new this(Calc.museum, 0);
    }
    calculate(level, era) {
        const museumStore = useMuseumStore();
        switch (this.__calc) {
            case 'callbackWithLevel':
            case 'callbackWithLevelAndEra':
                if (typeof this.__amount === 'function') {
                    return this.__amount(level, era);
                }
                return null;
            case 'museum':
                return museumStore.cultureBonus.value;
            default:
                return _Calculator[this.__calc](this.__amount, level, era);
        }
    }
}
export default EffectAmount;
